import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import Balcao from "../src/containers/Balcao/Balcao";
import Movimentacao from "../src/containers/Movimentacao/Movimentacao";
import { connect } from "react-redux";
import { logIn, logOut, setDados, setCadastrado, fetch, setTema, setLoged, setConnectionStatus, setIsManutencao, setAlertas, removeAlerta, setAtualizacao } from "./actions";
import Login from "./containers/Auth/Login";
import Logout from "./containers/Auth/Logout";
import CadastroGrupo from "./containers/Auth/CadastroGrupo";
import ErrorScreen from "./components/ErrorScreen";
import LoadingScreen from "./components/LoadingScreen";
import { ToastContainer } from 'react-toastify';
import ModalAuditoria from "./containers/Auth/ModalAuditoria";
import ModalValidacoes from "./reducers/ModalValidacoes";
import { useVerificarStatus } from "./components/Hooks/Conexao";
import Sobre from "./Sobre";
import UnavaibleScreen from "./components/UnavaibleScreen";
import { Alert } from "antd";
import { ProdutoLoteProvider } from "./Contexts/ProdutoLoteContext";
import CadastroGrupoToken from "./containers/Auth/CadastroGrupoToken";

export function Main(props) {
  const [loading, setLoading] = useState(false);
  const [errorIni, setErrorIni] = useState();
  const isCadastrado = props.isCadastrado;

  useVerificarStatus(!!props.auth.tokenId, props.setConnectionStatus, props.fetch);

  function handleTema(data) {
    props.setTema(!!data.layout ? "THEME_CUSTOM" : "THEME_DEFAULT", data?.layout, localStorage.getItem("THEME_DARK") === "true");
  }

  useEffect(() => {
    setLoading(true);

    props.fetch().post("auth/cadastrado").then(res => {
      const data = res.data;
      if (!!data.sucesso) {

        handleTema(data);

        props.setCadastrado(true, false, data.ambiente, data.alertas);
        setLoading(false);
      }
      else {
        props.setCadastrado(false, data.acessoRevogado, data.ambiente, data.alertas);
        setLoading(false);
      }

    }).catch(err => { setErrorIni(err); setLoading(false); });

  }, []);

  useEffect(() => {
    if (props.auth.tokenId) {
      props.fetch().post("auth/ini").then(response => {
        const data = response.data;

        handleTema(data);

        if (data.alertas?.length)
          props.setAlertas(data.alertas);

        if (data.sucesso) {
          props.setDados(data);

          props.setLoged(true);
        }
        else
          props.logOut();

        setLoading(false);
      }).catch(error => {
        if (error?.response?.data === "manutencao")
          props.setIsManutencao();
        else
          setErrorIni(error);

        setLoading(false);
      });
    }

  }, [props.auth.tokenId]);

  useEffect(() => {
    if (!!props.auth.tokenId && props.atualizacao == null) {
      props.fetch().post("outros/atu").then(d => {
        props.setAtualizacao(!!d.data.sucesso ? true : false);
        console.log('atualização versão concluída', !!d.data.sucesso);
      }).catch(error => {
        console.log('atualização versão com falha');
        console.log(error);
      });
    }
  }, [props.auth.tokenId]);

  if (props.statusServidor.isManutencao || props.statusServidor.isInativo)
    return <UnavaibleScreen title={props.statusServidor.isInativo && "Este PDV está inativo"} subTitle={props.statusServidor.isInativo && "Entre em contato com o suporte para mais informações."} />;

  if (errorIni)
    return <ErrorScreen />;

  if (loading || (!!props.auth.tokenId && !props.auth.loged && !errorIni))
    return <LoadingScreen loading noSpinner />;

  return <Router>
    <ProdutoLoteProvider>
      {props.auth.alertas?.map(alerta => <Alert key={alerta} style={{ zIndex: 5000, textAlign: "center" }} message={alerta} type="warning" closable afterClose={() => props.removeAlerta(alerta)} showIcon />)}
      {isCadastrado ? <>
        {props.auth.user ?
          <>
            {props.isCaixaAberto ? <Switch>
              <Route exact path="/" component={Balcao} />
              <Route exact path="/movimentacao" component={Movimentacao} />
              <Route exact path="/sair" component={Logout} />
              <Route exact path="/sobre" component={Sobre} />
              <Redirect to="/" />
            </Switch> :
              <Switch>
                <Route exact path="/" component={Balcao} />
                <Route exact path="/sair" component={Logout} />
                <Route exact path="/sobre" component={Sobre} />
                <Redirect to="/" />
              </Switch>}
            <ModalAuditoria />
            <ModalValidacoes />
          </>
          :
          <Switch>
            <Route exact path="/" component={Login} />
            <Route exact path="/sobre" component={Sobre} />
            <Redirect to="/" />
          </Switch>
        }
      </> :
        <Switch>
          <Route exact path="/" component={CadastroGrupo} />
          <Route exact path="/token/:versao/:chave/:pdv/:token" component={CadastroGrupoToken} />
          <Route exact path="/sobre" component={Sobre} />
          <Redirect to="/" />
        </Switch>}
    </ProdutoLoteProvider>

    <ToastContainer style={{ zIndex: 50001 }} limit={8} autoClose={1000} theme={props.tema.isDark ? "dark" : "light"} position="top-right" />
  </Router>;

}

const mapStateToProps = state => ({ auth: state.auth, dados: state.dados, isCadastrado: state.auth.isCadastrado, tema: state.tema, isCaixaAberto: state.auth.caixaAberto, statusServidor: state.statusServidor, atualizacao: state.atualizacao });

export default connect(mapStateToProps, { logIn, logOut, fetch, setDados, setCadastrado, setTema, setLoged, setConnectionStatus, setIsManutencao, setAlertas, setAtualizacao, removeAlerta })(Main);